import { render, staticRenderFns } from "./menuTabs.vue?vue&type=template&id=b2567eec&"
import script from "./menuTabs.vue?vue&type=script&lang=js&"
export * from "./menuTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports